import React from "react";

export function Kpi({ label, value, hint, testId }) {
  return (
    <div
      className="qrise-card qrise-card-hover p-6"
      data-testid={testId}
    >
      <div className="text-xs uppercase tracking-[0.18em] font-bold text-muted-foreground">
        {label}
      </div>
      <div className="mt-3 text-3xl font-semibold tracking-tight">{value}</div>
      {hint && (
        <div className="mt-1 text-xs text-muted-foreground">{hint}</div>
      )}
    </div>
  );
}
